import React, { Component } from 'react';
import { connect } from 'react-redux';

import InvoiceRow from './InvoiceRow';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_INVOICE_LINES', LOG_LEVELS.DEBUG);


class InvoiceLines extends Component {

  render() {
    log.debug('render(): ', this.props);

    const invoiceLines = this.props.invoiceLines;

    if (!invoiceLines) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <div>
        <h2 className="mt30"><LanguageStringResolver string='transactionInvoice_invoiceLines'/></h2>
        <InvoiceRow
          invoiceRows={invoiceLines}
          currency1={this.props.currency1}
          currency2={this.props.currency2}
          currency3={this.props.currency3}
        />
      </div>
  );
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceLines);
